import styled, { css } from "styled-components";
import { DEVICE_MAX } from "../../../constants/responsive";

/** Contenu principal centré */
export const Main = styled.main`
    max-width: var(--prh-max-width);
    width: 100%;
    margin: 0 auto;
    padding: 22px var(--prh-gutter) 70px;

    @media ${DEVICE_MAX.mobileL} {
        padding-inline: 16px;
    }

    /* état de chargement : on atténue le contenu le temps du recalcul */
    transition: opacity 0.15s;
    ${({ $loading }) =>
        $loading &&
        css`
            opacity: 0.45;
            pointer-events: none;
        `}
`;
